import React from 'react';
import Carousel from './base';
import { SmallPrevArrow, SmallNextArrow } from './arrows';

const defaultSliderSettings = {
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4 } },
    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } }
  ]
};

export default function MediumCarousel(props) {
  const sliderSettings = {
    ...defaultSliderSettings,
    lazyLoad: false,
    prevArrow: <SmallPrevArrow />,
    nextArrow: <SmallNextArrow />
  };

  return <Carousel {...sliderSettings} {...props} />;
}

export { defaultSliderSettings };
